import axios from "axios";
import { IP } from "../index";
// 查询一级分类 0 一级  1 二级
export async function selectCategory() {
  var resp = await axios.post(`${IP}/product/selectCategory`, {});
  return resp.data;
}
// 新增分类
export async function addCategory(data) {
  var resp = await axios.post(`${IP}/product/addCategory`, {
    ...data,
  });
  return resp.data;
}

// 修改分类
export async function updateCategory(data) {
  var resp = await axios.post(`${IP}/product/updateCategory`, {
    ...data,
  });
  return resp.data;
}

// 删除分类
export async function deleteCategory(id) {
  var resp = await axios.post(`${IP}/product/deleteCategory`, {
    id,
  });
  return resp.data;
}

// 模糊查商品
export async function selectGoods(data) {
  var resp = await axios.post(`${IP}/product/selectGoods`, {
    ...data,
  });
  return resp.data;
}

// 上传商品
export async function addGoods(data) {
  var resp = await axios.post(`${IP}/product/addGoods`, {
    ...data
  });
  return resp.data;
}

// 修改商品
export async function updateGoods(data) {
  var resp = await axios.post(`${IP}/product/updateGoods`, {
    ...data
  });
  return resp.data;
}

// 删除商品
export async function deleteGoodbyid(id) {
  var resp = await axios.post(`${IP}/product/deleteGoodsbyid`, {
    id,
  });
  return resp.data;
}

// 根据商品id删除所有商品
export async function deleteGoodsbygoodsId(goodsId) {
  var resp = await axios.post(`${IP}/myProduct/deleteGoodsbygoodsId`, {
    goodsId,
  });
  return resp.data;
}

/* ========详情图====== */

// 删除
export async function deleteImg(data) {
  var resp = await axios.post(`${IP}/product/deleteImg`, {
    ...data,
  });
  return resp.data;
}

// 查询
export async function selectImg(data) {
  var resp = await axios.post(`${IP}/product/selectImg`, {
    ...data,
  });
  return resp.data;
}

// 新增
export async function addImg(data) {
  var resp = await axios.post(`${IP}/product/addImg`, {
    ...data,
  });
  return resp.data;
}

// 修改
export async function updateImg(data) {
  var resp = await axios.post(`${IP}/product/updateImg`, {
    ...data,
  });
  return resp.data;
}
